import { format } from '@/utils/time.js';

export default (d, fmt, tz, locale) => d ? (format(d, fmt || 'relative', tz, locale) || 'just now') : null;
